import {observer} from "mobx-react";
import {CancelModalDialog, Page, PageContentTitle} from "../../ui";
import {DialogStore, fmsShippingClientCreateStore, growlStore} from "../../../store";
import {useState} from "react";
import {useNavigate} from "react-router";
import {FmsShippingClientForm} from "./FmsShippingClientForm";


const FmsShippingClientCreatePage = observer(function FmsShippingClientCreatePage() {
    const [cancelDialog] = useState(new DialogStore())
    const navigate = useNavigate()
    const display = 'Neuen Versandmandanten anlegen'

    const store = fmsShippingClientCreateStore

    return <Page
        breadcrumb={[
            {
                link: '/fms/shippingclient',
                label: 'Versandverwaltung'
            },
            {
                link: '/fms/shippingclient/create',
                label: display
            }
        ]}
    >
        <CancelModalDialog
            store={cancelDialog}
            execute={async () => {
                await store.reset()
            }}
        />
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${store.creating ? 'is-loading' : ''}`,
                    disabled: !(store.dirty && store.valid),
                    action: async () => {
                        const success = await store.create()
                        if (success) {
                            await store.reset()
                            growlStore.add({
                                message: 'Der Versandmandant wurde erfolgreich hinzugefügt',
                                autoclose: true,
                                closable: true
                            })
                            navigate(`/fms/shippingclient`)
                        }
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: store.creating || !store.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <FmsShippingClientForm
            disabled={store.creating}
            value={store.formData}
            validation={store.formValidation}
            onBlur={() => store.validate()}
            onChange={value => store.formData = value}
        />
    </Page>
})

export {
    FmsShippingClientCreatePage
}
